import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  private readonly STORAGE_KEY = 'User';

  constructor() {}

  private getPermissions(): string[] {
    const raw = localStorage.getItem(this.STORAGE_KEY);
    if (!raw) return [];

    try {
      const data = JSON.parse(raw);
      return data?.access ?? [];
    } catch (error) {
      console.warn('Invalid JSON in localStorage:', error);
      return [];
    }
  }

  hasPermission(permission: string): boolean {
    return this.getPermissions().includes(permission);
  }

  hasAllPermissions(permissions: string[]): boolean {
    const current = this.getPermissions();
    return permissions.every(p => current.includes(p));
  }

  hasAnyPermission(permissions: string[]): boolean {
    const current = this.getPermissions();
    return permissions.some(p => current.includes(p));
  }
}